// Тема дашборда: единственный признак — data-theme на <html>.
// CSS не знает про prefers-color-scheme: системную тему подставляем сюда же,
// иначе всю палитру пришлось бы описывать вторым блоком внутри @media.
const KEY = 'insightsTheme';
let watching = false;

function systemTheme() {
  return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark' : 'light';
}

export function restoreTheme() {
  const saved = localStorage.getItem(KEY);
  document.documentElement.dataset.theme = saved || systemTheme();
  // Пока пользователь не выбрал тему руками, следуем за системной.
  // Подписка одна на всё приложение: restoreTheme зовут несколько компонентов.
  if (saved || watching || !window.matchMedia) return;
  const mq = window.matchMedia('(prefers-color-scheme: dark)');
  const onChange = () => {
    if (localStorage.getItem(KEY)) return;
    document.documentElement.dataset.theme = mq.matches ? 'dark' : 'light';
  };
  if (mq.addEventListener) mq.addEventListener('change', onChange);
  else if (mq.addListener) mq.addListener(onChange);   // Safari < 14
  watching = true;
}

// Подписчиков может быть несколько, а слушатель окна нужен один: AppNav
// пересоздаётся на каждой навигации, и без этого обработчики копились бы.
const themeListeners = new Set();
let storageBound = false;

export function watchTheme(onChange) {
  themeListeners.add(onChange);
  if (!storageBound) {
    // Событие storage приходит только в другие вкладки, зацикливания нет.
    window.addEventListener('storage', event => {
      if (event.key !== KEY) return;
      const next = event.newValue || systemTheme();
      document.documentElement.dataset.theme = next;
      themeListeners.forEach(fn => fn(next));
    });
    storageBound = true;
  }
  return () => themeListeners.delete(onChange);
}

export function toggleTheme() {
  const root = document.documentElement;
  const next = root.dataset.theme === 'dark' ? 'light' : 'dark';
  root.dataset.theme = next;
  localStorage.setItem(KEY, next);
  return next;
}
